import CheckoutApi from '@support/checkoutApi';
import CartApi from '@support/cartApi';

class PaypalApi {
    constructor() {
    }

    setInstance(instance) {
        this.instance = instance;
    }

    async setupCheckout() {
        await CartApi.clearCart();

        return CartApi.addToCart(this.instance.variantData);
    }

    getPaymentObject(checkout, params) {
        const {data: {total}} = checkout;
        return {
            ...params,
            amount: parseFloat(total),
        };
    }

    async onShippingChange(payPalData, actions) {
        const {city, country_code, postal_code, state} = payPalData.shipping_address;
        const params = {
            zip_code: postal_code,
            country: country_code,
            city,
            state,
        };

        if (this.instance.totalWeight) {
            params.weight = this.instance.totalWeight;
        }

        try {
            const {data} = await CheckoutApi.getShipping(params);

            if (!data.data.length) {
                actions.reject();
            }

            const shippingMethod = data.data[0];

            const {service_code, package_code, price, label, original_price} = shippingMethod;

            if (!service_code || !package_code ||
                !shippingMethod.hasOwnProperty('price')) {
                actions.reject();
            }

            this.instance.$store.commit('shipping/setServiceCode',
                service_code);
            this.instance.$store.commit('shipping/setPackageCode',
                package_code);
            this.instance.$store.commit('shipping/setShippingMethodPreview',
                label);
            this.instance.$store.commit('shipping/setPriceTotal', price);

            await CheckoutApi.setShippingMethod({
                price,
                service_code,
                package_code,
                method_preview: label,
                original_price,
            });

            const checkoutData = await CheckoutApi.calculateTaxes(params);

            await this.instance.$store.dispatch('updateCheckout',
                checkoutData.data);

            const orderTotal = parseFloat(checkoutData.data.total);
            const subTotal = parseFloat(checkoutData.data.subtotal);
            const taxTotal = parseFloat(checkoutData.data.tax_total);
            const shippingAmount = parseFloat(checkoutData.data.shipping);
            const discount = parseFloat(checkoutData.data.discount_total);

            return actions.order.patch([
                {
                    op: 'replace',
                    path: '/purchase_units/@reference_id==\'default\'/amount',
                    value: {
                        currency_code: 'USD',
                        value: (orderTotal).toFixed(2),
                        breakdown: {
                            item_total: {
                                currency_code: 'USD',
                                value: subTotal,
                            },
                            tax_total: {
                                currency_code: 'USD',
                                value: taxTotal,
                            },
                            shipping: {
                                currency_code: 'USD',
                                value: shippingAmount,
                            },
                            discount: {
                                currency_code: 'USD',
                                value: discount,
                            },
                        },
                    },
                },
            ]);
        } catch (e) {
            console.error('unable get the shipping methods for paypal', e);
            actions.reject();
        }
    }

    async normalizeCheckoutRequest(data, actions, payload) {
        const {details} = payload;

        const contact = this.getContact(details);

        return {
            contact,
            shipping: this.getShipping(details),
            billing: this.getBilling(details),
            payment_data: Object.assign({}, payload,
                {deviceData: this.instance.deviceData}),
            payment_type: this.instance.paymentMethodName,
        };
    }

    getContact(details) {
        return {
            phone: details.phone,
            email: details.email,
        };
    }

    getShipping(details) {
        const data = this.instance.$store.state.shipping;

        return {
            address_line_1: details.shippingAddress.line1,
            address_line_2: details.shippingAddress.line2 || '',
            city: details.shippingAddress.city,
            company: '',
            country: details.shippingAddress.countryCode || 'US',
            email: details.email || '',
            first_name: details.firstName,
            last_name: details.lastName,
            package_code: data.package_code,
            service_code: data.service_code,
            shipping_email: details.email || '',
            shipping_method_preview: data.shipping_method_preview,
            state: details.shippingAddress.state,
            zip_code: details.shippingAddress.postalCode,
        };
    }

    getBilling(details) {
        return {
            address_line_1: details.shippingAddress.line1 || '',
            address_line_2: details.shippingAddress.line2 || '',
            city: details.shippingAddress.city,
            company: '',
            country: details.shippingAddress.countryCode || 'US',
            first_name: details.firstName,
            last_name: details.lastName,
            state: details.shippingAddress.state,
            zip_code: details.shippingAddress.postalCode,
            email: details.email || '',
            phone: details.phone,
            isSameAsShipping: false,
        };
    }
}

export default new PaypalApi();
